import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ProcedimentoAgendaFiltroDTO } from '../../../dtos/procedimento-agenda-filtro-dto';
import { Filial } from '../../../filial/filial';
import { FilialService } from '../../../filial/filial.service';
import { Medico } from '../../../medico/medico';
import { MedicoService } from '../../../medico/medico.service';
import { ChaveValorNumberInterface } from '../../../util/chave-valor-number-interface';
import { Horario } from '../../../util/hora-atendimeno';
import { Util } from '../../../util/util';
import { Procedimento } from '../../procedimento';
import { ProcedimentoAgendaPk } from '../pks/procedimento-agenda-pk';
import { ProcedimentoAgenda } from '../procedimento-agenda';
import { ProcedimentoAgendaTomada } from '../procedimento-agenda-tomada';
import { ProcedimentoAgendaService } from '../procedimento-agenda.service';

@Component({
  selector: 'app-procedimento-agenda-maintenance',
  templateUrl: './procedimento-agenda-maintenance.component.html',
  styleUrls: ['./procedimento-agenda-maintenance.component.css']
})
export class ProcedimentoAgendaMaintenanceComponent implements OnInit {

  id: ProcedimentoAgendaPk;

  isUpdate: string;

  isInfo: boolean = false;

  procedimentoAgenda: ProcedimentoAgenda;

  formularioDeCadastroProcedimentoAgenda: FormGroup;

  tituloCrud: string = '';

  listaDiasDaSemana: ChaveValorNumberInterface[] = Util.listaDiasDaSemana;

  listaHorarios: Horario[] = Util.listaHorasAtendimentos;

  listaFiliais: Filial[] = [];

  listaMedicos: Medico[] = [];

  filtroProcedimentoAgenda: ProcedimentoAgendaFiltroDTO;

  procedimentoSelecionado: Procedimento | null;

  medicoSelecionado: Medico | null = null;

  numeroDaLinhaSelecionadaNaTabelaDeTomadas: number = -1;

  onClickNaTabelaDeTomadas: any;

  desabilitarCadastroDeTomadas = true;

  listaTomadas: Array<ProcedimentoAgendaTomada> = [];

  constructor(private procedimentoAgendaService: ProcedimentoAgendaService,
    private medicoService: MedicoService,
    private filialService: FilialService,
    private router: Router,
    private formBuilder: FormBuilder,
    private cd: ChangeDetectorRef) {

    this.id = history.state.id;

    this.isUpdate = history.state.isUpdate;

    this.procedimentoAgenda = new ProcedimentoAgenda();

    this.filtroProcedimentoAgenda = history.state.filtroProcedimentoAgenda;

    if (this.filtroProcedimentoAgenda && this.filtroProcedimentoAgenda.procedimento) {
      this.procedimentoSelecionado = this.filtroProcedimentoAgenda.procedimento;
    } else {
      this.procedimentoSelecionado = null;
    }

    this.formularioDeCadastroProcedimentoAgenda = this.formBuilder.group({
      quantidadeAtdGeral: [null, [Validators.required]],
      medico: [null, [Validators.required]],
      dataInicioAgenda: ['', [Validators.required]],
      atdIdadeMinima: [null],
      atdIdadeMaxima: [null],
      pk: this.formBuilder.group({
        idFilial: [{ value: null }, [Validators.required]],
        idProcedimento: [{ value: null, disabled: true }, [Validators.required]],
        diaSemana: [null, [Validators.required]],
        horaAtendimento: [null, [Validators.required]],
      })
    });

    this.onClickNaTabelaDeTomadas = function (index: number) {
      this.numeroDaLinhaSelecionadaNaTabelaDeTomadas = index;
    }
  }

  ngOnInit() {

    if (this.id) {
      if (this.isUpdate == 'S') {
        this.tituloCrud = 'Alterar Procedimento Agenda';
      } else {
        this.isInfo = true;
        this.tituloCrud = 'Detalhe Procedimento Agenda';
      }
    } else {
      this.tituloCrud = 'Criar Procedimento Agenda';
    }

    this.listarFiliais();

    this.listarMedicos();
  }

  save() {

    this.procedimentoAgenda = Object.assign(new ProcedimentoAgenda(), this.formularioDeCadastroProcedimentoAgenda.value);

    if (this.isUpdate == 'S') {

      this.procedimentoAgenda.pk = this.id;
      if (this.medicoSelecionado) {
        this.procedimentoAgenda.medico = this.medicoSelecionado;
      }

      if (this.listaTomadas && this.listaTomadas.length > 0) {
        this.procedimentoAgenda.tomadas = this.listaTomadas;
      }

    } else if (this.procedimentoSelecionado) {

      this.procedimentoAgenda.pk.idProcedimento = this.procedimentoSelecionado.id;

    }

    if (this.isNew()) {
      this.procedimentoAgendaService
        .criarAgenda(this.procedimentoAgenda).subscribe(data => {
          // console.log(data)

          this.gotoList();
        }, error => {
          console.log(error);
        });
    } else {
      this.procedimentoAgendaService.atualizarAgenda(this.procedimentoAgenda)
        .subscribe(data => {
          // console.log(data);

          this.gotoList();
        }, error => {
          console.log(error);
        });
    }
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/procedimentoAgenda'], {
      state: {
        filtroProcedimentoAgenda: history.state.filtroProcedimentoAgenda,
      }
    });
  }

  isNew(): boolean {
    return this.id == null || this.id.idMedico == 0;
  }

  get formControl() {
    return this.formularioDeCadastroProcedimentoAgenda.controls;
  }

  listarMedicos() {

    this.medicoService.listarComProjecao()
      .subscribe(data => {

        // console.log(data)
        this.listaMedicos = data;

        this.configurarForm();

      }, error => {
        console.log(error);
      });
  }

  listarFiliais() {

    this.filialService.listarComProjecao()
      .subscribe(data => {

        // console.log(data)
        this.listaFiliais = data;

      }, error => {
        console.log(error);
      });
  }

  configurarForm(): void {

    // Verifica se e para desabilitar o cadastro de tomada
    this.desabilitarCadastroDeTomadas = this.isInfo || !this.id;

    if (history.state.procedimentoAgenda) {

      this.procedimentoAgenda = Object.assign(new ProcedimentoAgenda(), history.state.procedimentoAgenda);

      this.id = this.procedimentoAgenda.pk;

      this.configurarProcedimentoAgenda();

    } else if (!this.isNew()) {

      this.procedimentoAgendaService.procurarAgendaPorPk(this.id)
        .subscribe(data => {
          // console.log(data)

          this.procedimentoAgenda = Object.assign(new ProcedimentoAgenda(), data);

          this.configurarProcedimentoAgenda();

        }, error => {
          console.log(error);
        });
    } else {
      // Configurar Campo Medico
      if (this.procedimentoSelecionado && this.formularioDeCadastroProcedimentoAgenda) {
        this.formularioDeCadastroProcedimentoAgenda.controls.pk.get('idProcedimento')?.patchValue(this.procedimentoSelecionado.nome);
      }
    }
  }

  configurarProcedimentoAgenda(): void {

    this.formularioDeCadastroProcedimentoAgenda.patchValue(this.procedimentoAgenda);

    // Configurar Campo Procedimento
    if (this.procedimentoSelecionado && this.formularioDeCadastroProcedimentoAgenda) {
      this.formularioDeCadastroProcedimentoAgenda.controls.pk.get('idProcedimento')?.patchValue(this.procedimentoSelecionado.nome);
    }

    //Configurar Medico Selecionado
    let currentMedico = this.listaMedicos.filter(med => med.id == this.procedimentoAgenda.pk.idMedico)[0];
    this.formularioDeCadastroProcedimentoAgenda.controls.medico.patchValue(currentMedico);

    this.medicoSelecionado = this.procedimentoAgenda.medico;

    // Configurar horario selecionado
    let currentHorario = this.listaHorarios.filter(hor => hor.descricao == Util.getHoraFormatada(this.procedimentoAgenda.pk.horaAtendimento))[0];
    this.formControl.pk.get('horaAtendimento')?.patchValue(currentHorario.codigo);

    this.listaTomadas = this.procedimentoAgenda.tomadas;

    // Ordernar lista
    if (this.listaTomadas) {
      this.listaTomadas.sort(function (t1, t2) { return parseInt(t1.pk.horaTomada) - parseInt(t2.pk.horaTomada); });
    }

    this.cd.detectChanges();

    if (this.isUpdate == 'N') {
      this.formularioDeCadastroProcedimentoAgenda.disable();
    } else {
      this.formularioDeCadastroProcedimentoAgenda.controls.pk.get('idFilial')?.disable();
      this.formularioDeCadastroProcedimentoAgenda.controls.pk.get('idProcedimento')?.disable();
      this.formularioDeCadastroProcedimentoAgenda.controls.medico.disable();
      this.formularioDeCadastroProcedimentoAgenda.controls.pk.get('diaSemana')?.disable();
      this.formularioDeCadastroProcedimentoAgenda.controls.pk.get('horaAtendimento')?.disable();
    }
  }

  removerTomadaSelecionada(): void {
    if (this.numeroDaLinhaSelecionadaNaTabelaDeTomadas != -1 && this.listaTomadas) {
      this.listaTomadas.splice(this.numeroDaLinhaSelecionadaNaTabelaDeTomadas, 1)
    }
  }

  atualizarAtributosDoFormNaEntidadeTomada(): void {
    this.procedimentoAgenda.quantidadeAtdGeral = this.formularioDeCadastroProcedimentoAgenda.controls.quantidadeAtdGeral.value;
  }

  navegarParaTelaDeCadastroDeTomadas(): void {

    this.atualizarAtributosDoFormNaEntidadeTomada();

    this.router.navigate(['/cadastroTomada'], {
      state: {
        id: this.id,
        isUpdate: this.isUpdate,
        procedimentoAgenda: this.procedimentoAgenda,
        filtroProcedimentoAgenda: history.state.filtroProcedimentoAgenda,
      }
    });
  }

  voltarPaginaAnterior(): void {
    this.router.navigate(['/procedimentoAgenda'], {
      state: {
        filtroProcedimentoAgenda: this.filtroProcedimentoAgenda,
      }
    });
  }
}
